import React, { Component } from "react"
import { Link } from "react-router"
import { text, options, image } from "../../attributes/items/primitives"

export default class ImageBlockType extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper

        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, evaluateFormulas }) => {
                    const linkWrapper = children =>
                        evaluateFormulas(attrs.link).indexOf("://") == -1 ? (
                            <Link to={attrs.link}>{children}</Link>
                        ) : (
                                <a href={attrs.link}>{children}</a>
                            )
                    const wrapLink =
                        attrs.link && !this.props.context.editor.isEditing ? linkWrapper : a => a
                    const src = evaluateFormulas(attrs.src)
                    const tooltip = evaluateFormulas(attrs.tooltip)
                    if (attrs.size === "contain" || attrs.size === "cover") {
                        return (
                            wrapLink(<div
                                alt=""
                                src={src}
                                style={{
                                    ...computedStyle,
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    height: "100%",
                                    width: "100%",
                                    backgroundImage: "url(" + src + ")",
                                    backgroundSize: attrs.size,
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                }}
                                title={tooltip}
                            />)
                        )
                    } else {
                        return wrapLink(
                            <img
                                alt=""
                                src={src}
                                style={{
                                    ...computedStyle,
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    height: "100%",
                                }}
                                title={tooltip}
                            />
                        )
                    }
                }}
            </Wrapper>
        )
    }

    saveEditsUntilUnselected(edit, callback) {
        // Mutate directly so we don't update
        this.state.edits.edit = edit
        this.state.edits.callback = callback
    }

    componentWillUpdate() {
        if (this.state.edits.edit) {
            this.state.edits.callback("text", this.state.edits.edit)
            this.state.edits = { edit: null, callback: null }
        }
    }
}

ImageBlockType.attributes = [
    text({ field: "src", label: "Source URL" }),
    text({ field: "link", label: "Link to Page" }),
    options({
        field: "size",
        label: "Display Size",
        options: [
            { label: "Fit height", value: "height" },
            { label: "Fit frame", value: "contain" },
            { label: "Fill frame", value: "cover" },
        ],
    }),
    text({ field: "tooltip", label: "Tooltip" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/basic/ImageBlock.js